<template>
  <div class="technical-screen results">
    <dl class="panels">
      <div>
        <dt>{{ $t('uptime') }}</dt>
        <dd>
          <span class="value">
            <NumberDisplay :value="results.uptime" suffix="%" :digits="2" />
          </span>
        </dd>
      </div>
      <div>
        <dt>{{ $t('uptime bonus') }}</dt>
        <dd>
          <span class="value">
            <MoneyDisplay :value="results.uptimeBonus" />
          </span>
        </dd>
      </div>
    </dl>

    <UptimePerClient :uptime="results.uptimePerClient" />
  </div>
</template>

<script setup lang="ts">
import MoneyDisplay from '/@front:components/MoneyDisplay.vue'
import NumberDisplay from '/@front:components/NumberDisplay.vue'
import UptimePerClient from '/@front:components/results/UptimePerClient.vue'
import GameLayout from '/@front:layouts/game.vue'
import type { ScenarioClientWithUptime } from '/@front:types/shared'

defineOptions({
  layout: [GameLayout],
})

defineProps<{
  results: {
    uptime: number
    uptimeBonus: number
    uptimePerClient: ScenarioClientWithUptime[]
  }
}>()
</script>
